export const MAX_FILE_SIZE_BYTES = 10 * 1024 * 1024;  // 10MB
export const MAX_TOTAL_SIZE_BYTES = 30 * 1024 * 1024; // 30MB

export const ALLOWED_MIME_TYPES = new Set([
  "application/pdf",
  "application/msword",                                                        // .doc
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document",  // .docx
  "image/jpeg",                                                                // .jpg / .jpeg
  "image/png",
]);
export const MAX_UPLOAD_RETRIES = 2;
